export const GET_BACKSTAGE = "GET_BACKSTAGE";
export const INSERT_BACKSTAGE = "INSERT_BACKSTAGE";
export const UPDATE_BACKSTAGE = "UPDATE_BACKSTAGE";
export const DELETE_BACKSTAGE = "DELETE_BACKSTAGE";
export const TOGGLE_BACKSTAGE_STATUS = "TOGGLE_BACKSTAGE_STATUS";
